<button
    class="flex items-center gap-4 bg-transparent border-none text-shui-text-strong cursor-pointer"
    [id]="targetId()"
>
    <span class="whitespace-nowrap">{{ label() }}</span>
    @if (selectedValues().length > 0) {
        <sh-badge [label]="'' + selectedValues().length" size="medium" variant="rounded"></sh-badge>
    }
    <sh-icon icon="arrow-face-down-midi" size="sm"></sh-icon>
</button>
<sh-popover [target]="targetId()" position="bottom-left" style="max-height: 300px; overflow-y: auto">
    @if (searchable()) {
        <sh-input-text
            [label]="searchPlaceholder()"
            [value]="searchTerm()"
            condensed
            (value-changed)="onSearchInput($event)"
            (click)="$event.stopPropagation()"
        ></sh-input-text>
    }
    @for (option of filteredOptions(); track option.value) {
        <sh-menu-item
            [label]="
                (optionTranslationPrefix() ? [optionTranslationPrefix(), option.label].join('.') : option.label)
                    | translate
            "
            [active]="isOptionActive(option.value)"
            (click)="toggleItem(option.value)"
        ></sh-menu-item>
    }
</sh-popover>
